/**
 * ════════════════════════════════════════════════════════════════════
 *  KINGZ.COM — PHASE 2, FIX 7: INTERSECTION OBSERVER LAZY LOADERS
 *  File: assets/kingz-lazy-widgets.js
 *  Deployed: April 6, 2026
 *  Impact: Defers widget rendering until sections enter viewport
 *  Risk:   Low — widgets load before user reaches them (400px margin)
 * ════════════════════════════════════════════════════════════════════
 *
 *  HOW IT WORKS:
 *  - Watches elements with data-lazy-widget attributes via IntersectionObserver
 *  - Loads widget scripts only when their container is 400px from viewport
 *  - Auto-detects .jdgm-review-widget on product pages (no HTML changes needed)
 * ════════════════════════════════════════════════════════════════════
 */

(function() {
  'use strict';

  var OBSERVER_OPTIONS = {
    root:       null,
    rootMargin: '400px',
    threshold:  0,
  };

  // ── JUDGE.ME LAZY LOADER ─────────────────────────────────────────
  function lazyLoadJudgeMe(container) {
    var JUDGEME_SCRIPT_ID = 'judgeme-widget-script';
    if (document.getElementById(JUDGEME_SCRIPT_ID)) return;
    var script = document.createElement('script');
    script.src   = 'https://cdn.judge.me/shopify_widgets/apps.js';
    script.id    = JUDGEME_SCRIPT_ID;
    script.async = true;
    if (window.Shopify && window.Shopify.shop) {
      script.setAttribute('data-shop-domain', window.Shopify.shop);
    }
    script.addEventListener('load', function() {
      console.log('[Kingz] Judge.me reviews loaded as section entered viewport.');
    });
    document.head.appendChild(script);
  }

  // ── GENERIC WIDGET LOADER ────────────────────────────────────────
  function lazyLoadGenericScript(container) {
    var scriptUrl = container.dataset.lazyScript;
    var scriptId  = container.dataset.lazyId || 'lazy-script-' + Date.now();
    if (!scriptUrl || document.getElementById(scriptId)) return;
    var script = document.createElement('script');
    script.src   = scriptUrl;
    script.id    = scriptId;
    script.async = true;
    script.addEventListener('load', function() {
      console.log('[Kingz] Lazy script loaded:', scriptId);
    });
    document.head.appendChild(script);
  }

  // ── INTERSECTION OBSERVER ────────────────────────────────────────
  var observer = new IntersectionObserver(function(entries, obs) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      var el   = entry.target;
      var type = el.dataset.lazyWidget;
      if (type === 'judgeme')  lazyLoadJudgeMe(el);
      if (type === 'generic')  lazyLoadGenericScript(el);
      obs.unobserve(el);
    });
  }, OBSERVER_OPTIONS);

  // ── OBSERVE ELEMENTS WITH data-lazy-widget ───────────────────────
  document.querySelectorAll('[data-lazy-widget]').forEach(function(el) {
    observer.observe(el);
  });

  // ── FALLBACK (no IntersectionObserver support) ───────────────────
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-lazy-widget]').forEach(function(el) {
      var type = el.dataset.lazyWidget;
      if (type === 'judgeme')  lazyLoadJudgeMe(el);
      if (type === 'generic')  lazyLoadGenericScript(el);
    });
  }

  console.log('[Kingz] Intersection Observer lazy widget loader initialized.');

})();